import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconChat } from '@redteclab/icons'

import { useOpenableControls } from '../../../generic-hooks'
import { PersonalAdviceDialog } from '../../../personal-advice'
import { ProductBuyBoxButton } from '../ProductBuyBoxIcons/ProductBuyBoxButton'
import { useProductPageContext } from '../productPageContext'

export const ProductPagePersonalAdviceButton: FC = () => {
  const dialogControls = useOpenableControls()
  const { product } = useProductPageContext()

  return (
    <>
      <ProductBuyBoxButton
        onClick={dialogControls.handleOpen}
        startIcon={<IconChat />}
      >
        <FormattedMessage id="buyBox.link.label.personalAdvice" />
      </ProductBuyBoxButton>
      <PersonalAdviceDialog dialogControls={dialogControls} product={product} />
    </>
  )
}
